import { Inscription } from './inscription.model';

export class InscriptionVin extends Inscription {
    static jsonMap = {
        ...Inscription.jsonMap,
        cvi: { key: 'cvi', optional: true, default: '' },
        ppm: { key: 'ppm', optional: true, default: '' },
        accise: { key: 'accise', optional: true, default: '' }
    };

    cvi: string;
    ppm: string;
    accise: string;
}
